import Popup from 'reactjs-popup';
import Select from 'react-select'
import 'reactjs-popup/dist/index.css';
import React, { useEffect, useState } from 'react'
import { useAuthState } from '../../../../Helper/Context';
import { useDispatch } from 'react-redux';
import { ContractorNamePostDataAPI } from '../../../../Redux/SidebarMasterSlice/ContractorNameSlice';
import { RegExOnlyText } from '../../../../Helper/regEx/RegExOnlyText';
import { AstricSign } from '../../../../Helper/AstricSign';
import { ProjectTypeDataDDL } from '../../../../Components/CommonDDL/ProjectTypeDataDDL';


export default function ContractorNamePopup(props) {

    const { handleOnCloseClick, open, item, Flag, handleIsPost, apiFlag, rowData } = props

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const dispatch = useDispatch()
    const [IsPost, setIsPost] = useState(false)
    const [ProjectType, setProjectType] = useState({
        DDL: [],
        ID: Flag === 'Update' ? rowData.m_ProjectTypeID : 0,
        Label: Flag === 'Update' ? rowData.projectType : "Select...",
    })


    // const [rowData, setRowData] = useState(item)
    const [IsValidNumbers, setIsValidNumbers] = useState(false)
    const [IsValidEmail, setIsValidEmail] = useState(false)
    const [ContractorNameField, setContractorNameField] = useState({
        ContractorName: Flag === 'Update' ? rowData.contractorName : '',
        Address: Flag === 'Update' ? rowData.address : '',
        ContactPersonName: Flag === 'Update' ? rowData.contactPersonName : '',
        MobileNumber: Flag === 'Update' ? rowData.mobileNo : '',
        EmailID: Flag === 'Update' ? rowData.emailID : '',
    });

    const [IsOpen, setIsOpen] = useState(false)

    // useEffect(() => {
    //     setContractorNameField({
    //         ContractorName: Flag === 'Update' ? rowData.contractorName : '',
    //         Address: Flag === 'Update' ? rowData.address : '',
    //         ContactPersonName: Flag === 'Update' ? rowData.contactPersonName : '',
    //         MobileNumber: Flag === 'Update' ? rowData.mobileNo : '',
    //         EmailID: Flag === 'Update' ? rowData.emailID : '',
    //     })
    // }, [item, IsOpen])


    const handleContractorField = (e) => {
        setContractorNameField({ ...ContractorNameField, [e.target.name]: e.target.value })
    }

    const [IsValidText, setIsValidText] = useState(false)
    const handleCheckText = (e) => {
        handleContractorField(e)
        const IsValid = RegExOnlyText(e.target.value)
        setIsValidText(IsValid)
        return IsValid
    }

    const [OnlyText, setOnlyText] = useState(false)
    const handleOnlyText = (e) => {
        handleContractorField(e)
        const OnlyText = RegExOnlyText(e.target.value)
        setOnlyText(OnlyText)
        return OnlyText
    }


    const handleCheckMobileNumber = (e) => {
        handleContractorField(e)
        let regex = new RegExp(/^[0-9]*$/)
        if (regex.test(e.target.value) || e.target.value === "") {
            setIsValidNumbers(false)
        } else {
            setIsValidNumbers(true)
        }
    }

    const handleCheckEmail = (e) => {
        handleContractorField(e)
        let regex = new RegExp(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/)
        if (regex.test(e.target.value) || e.target.value === "") {
            setIsValidEmail(false)
        } else {
            setIsValidEmail(true)
        }
    }

    const handlePost = () => {
        const data = {
            M_ContractorID: Flag === 'Update' ? rowData.m_ContractorID : '0',
            M_ProjectTypeID: ProjectType.ID,
            ContractorName: ContractorNameField.ContractorName,
            Address: ContractorNameField.Address,
            MobileNo: ContractorNameField.MobileNumber,
            EmailID: ContractorNameField.EmailID,
            ContactPersonName: ContractorNameField.ContactPersonName,
            M_UserID: UserID,
            token: token,
            Flag: Flag,
            handleIsPost: handleIsPost,
            handleOnCloseClick: handleOnCloseClick
        }
        dispatch(ContractorNamePostDataAPI({ data }))
    }

    return (

        // <Popup
        //     onOpen={() => setIsOpen(!IsOpen)}
        //     contentStyle={{ top: '5%' }}
        //     trigger={
        //         Flag === 'Update' ?
        //             <i className="fa-solid fa-pen-to-square"></i>
        //             :
        //             <i className="fa-solid fa-plus btn btn-secondary mb-2 float-end" style={{ color: "white", marginTop: '-2.5em' }}>
        //                 <text className="ml-2 poppins">Add</text>
        //             </i>
        //     }
        //     modal>

        //     {
        <Popup
            open={open} closeOnDocumentClick={false} onClose={handleOnCloseClick}
        >

            <div className="area_pop modal-dialog modal-xl">
                <div className="modal-content master_border">
                    <div className="modal-header pl-4 p-1">
                        <h4 className="modal-title" id="staticBackdropLabel">Contractor Name</h4>
                        <button onClick={handleOnCloseClick} className="btn-close m-1 mr-3" type="button" />
                    </div>

                    <div className="modal-body">
                        <div className='inner-modal-body'>

                            <div className="row details-row">
                                <div className="col-lg-6 col-md-6">
                                    <ProjectTypeDataDDL
                                        ProjectType={ProjectType}
                                        setProjectType={setProjectType}
                                        rowData={rowData}
                                        Flag={Flag}
                                        IsPost={IsPost}
                                    />

                                </div>
                                <div className="col-12 col-lg-6">
                                    <label for=""><b>Contractor Name <AstricSign /> </b></label>
                                    <input type="text" className="form-control" id="exampleInputEmail1"
                                        aria-describedby="emailHelp"
                                        name='ContractorName'
                                        value={ContractorNameField.ContractorName}
                                        // onChange={(e) => handleCheckText(e)}                                    
                                        onChange={(e) => handleContractorField(e)}
                                    />
                                    {/* {
                                        IsValidText && <text style={{ color: 'red' }}>Please enter Alphabets characters only</text>
                                    } */}
                                </div>

                                <div className="col-12 col-lg-6  ">
                                    <label for=""><b>Address <AstricSign /> </b></label>
                                    <input type="text" className="form-control" id="exampleInputEmail1"
                                        aria-describedby="emailHelp"
                                        name='Address'
                                        value={ContractorNameField.Address}
                                        onChange={handleContractorField}
                                    />
                                </div>

                                <div className="col-12 col-lg-6 mt-2 ">
                                    <label for=""><b>Contact Person Name <AstricSign /> </b></label>
                                    <input type="text" className="form-control" id="exampleInputEmail1"
                                        aria-describedby="emailHelp"
                                        name='ContactPersonName'
                                        value={ContractorNameField.ContactPersonName}
                                        onChange={(e) => handleContractorField(e)}
                                    // onChange={(e) => handleOnlyText(e)}
                                    />
                                    {/* {
                                        OnlyText && <text style={{ color: 'red' }}>Please enter Alphabets characters only</text>
                                    } */}
                                </div>

                                <div className="col-12 col-lg-6 mt-2 ">
                                    <label for=""><b>Mobile Number </b></label>
                                    <input type="text" className="form-control" id="exampleInputEmail1"
                                        aria-describedby="emailHelp"
                                        name='MobileNumber'
                                        value={ContractorNameField.MobileNumber}
                                        onChange={handleCheckMobileNumber}
                                        maxLength={10}
                                    />
                                    {
                                        IsValidNumbers && <text style={{ color: 'red' }}>Please Enter valid Mobile Number</text>
                                    }
                                </div>

                                <div className="col-12 col-lg-6 mt-2">
                                    <label for=""><b>Email ID :</b></label>
                                    <input type="text" className="form-control" id="exampleInputEmail1"
                                        aria-describedby="emailHelp"
                                        name='EmailID'
                                        value={ContractorNameField.EmailID}
                                        onChange={handleCheckEmail}
                                    />
                                    {
                                        IsValidEmail && <text style={{ color: 'red' }}>Please Enter valid Email</text>
                                    }
                                </div>

                            </div>
                            {/* 
                                    <div className="mb-4 pt-4">
                                        <div className="float-end">
                                                 <button className="submit_btn"
                                                 disabled={
                                                    ContractorNameField.ContractorName === '' && ContractorNameField.Address === '' && ContractorNameField.ContactPersonName === ''
                                                 }
                                                 onClick={() => (handlePost())
 
                                                 }
                                             >{Flag === "Update" ? "Update" : "Save"} </button>
                                            <button className=" cancel_btn ms-2" onClick={handleOnCloseClick} >Cancel</button>
                                        </div>
                                    </div> */}

                            <div className="col-12 col-lg-12  pt-md-4 pt-4">
                                <div className="btn-action d-flex justify-content-end">

                                    <button type='button'
                                        className="btn allBtn  float-right submit_btn"
                                        onClick={() => handlePost()}
                                        disabled={
                                            ContractorNameField.ContractorName == '' || ContractorNameField.Address == '' || ContractorNameField.ContactPersonName == ''
                                        }
                                    >{Flag === "Update" ? "Update" : "Save"} </button>

                                    <button type="button" className="btn addBtns cancel_btn ms-2 mr-2 mx-2  float-right" onClick={handleOnCloseClick} >Cancel</button>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            {/* )} */}
        </Popup>
    )

}